import React from 'react';
import './Header.css';
import Image01 from '../Image/icon-2.png';

const Header = () => {
    return (
        <div className='container-fluid bg-dark text-light p-3 header'>
            <div className="row d-flex flex-row justify-content-between align-items-center">
                <div className="col-sm-12 col-md-12 header-info">
                    <img src={Image01} alt="" />
                    <h1>SM's Body Builder</h1>
                    <p className='text-muted'><i>Select Today's Exercise</i></p>
                </div>
            </div>

        </div>
    );
};

export default Header;